import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import {
  Grid,
  FormControl,
  TextField,
  FormControlLabel,
  Checkbox,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";
import ApiEndpoints from "../../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import { postJsonData } from "../../network/ApiController";
import Loader from "../../component/loading-screen/Loader";
import { primaryColor } from "../../theme/setThemeColor";
import { useState, useEffect, useContext } from "react";
import { PATTERNS } from "../../utils/ValidationUtil";
import ModalHeader from "../ModalHeader";
import ModalFooter from "../ModalFooter";
import AuthContext from "../../store/AuthContext";
import { AEPS_TYPE } from "../../utils/constants";
import Aeps1OutletStatusIpay from "../../component/Aeps1OutletStatusIpay";
import useCommonContext from "../../store/CommonContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
  height: "max-content",
  overflowY: "scroll",
};

const AePSOutletRegistration = ({ open, setOpen, refresh, aepsType }) => {
  const [isConsent, setIsConsent] = useState(false);
  const [isValMob, setIsValMob] = useState(true);
  const [request, setRequest] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusReferenceId, setStatusReferenceId] = useState("");

  // New state variables for additional fields
  const [name, setName] = useState("");
  const [gender, setGender] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [address, setAddress] = useState({
    full: "",
    city: "",
    pincode: "",
  });
  const [isValidPincode, setIsValidPincode] = useState(true);
  const [isValidDate, setIsValidDate] = useState(true);
  const [isValidName, setIsValidName] = useState(true);
  const [isValidGender, setIsValidGender] = useState(true);
  const { refreshUser } = useCommonContext();

  const user = useContext(AuthContext);
  const userLat = user.location.lat;
  const userLong = user.location.long;

  useEffect(() => {
    // Reset states when modal closes
    if (!open) {
      setIsConsent(false);
      setIsValMob(true);
      // setShowStatusModal(false);
      setName("");
      setGender("");
      setDateOfBirth("");
      setAddress({ full: "", city: "", pincode: "" });
      setIsValidPincode(true);
      setIsValidDate(true);
      setIsValidName(true);
      setIsValidGender(true);
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
    setIsConsent(false);
    setIsValMob(true);
    // setShowStatusModal(false);
    setName("");
    setGender("");
    setDateOfBirth("");
    setAddress({ full: "", city: "", pincode: "" });
    setIsValidPincode(true);
    setIsValidDate(true);
    setIsValidName(true);
    setIsValidGender(true);
  };

  const outletRegistration = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    // Validate name
    if (!name.trim()) {
      setIsValidName(false);
      return;
    }
    setIsValidName(true);

    // Validate gender
    if (!gender) {
      setIsValidGender(false);
      return;
    }
    setIsValidGender(true);

    // Validate date of birth
    if (!dateOfBirth) {
      setIsValidDate(false);
      return;
    }
    setIsValidDate(true);

    // Validate mobile number
    const mobile = form.mobile.value;
    if (!PATTERNS.MOBILE.test(mobile)) {
      setIsValMob(false);
      return;
    }
    setIsValMob(true);

    setIsValidPincode(true);

    const data = {
      name: name,
      gender: gender,
      dateOfBirth: dateOfBirth,
      mobile: mobile,
      pan: form.pan.value,
      aadhaar: form.aadhaar.value,
      email: form.emailId.value,
      bankAccountNo: form.bankAccountNo.value,
      bankIfsc: form.bankIfsc.value,
      latitude: userLat,
      longitude: userLong,
      address: {
        full: address.full,
        city: address.city,
        pincode: address.pincode,
      },
    };

    postJsonData(
      ApiEndpoints.AEPS_MIN_KYC,
      data,
      setRequest,
      (res) => {
        okSuccessToast(res?.data?.message);
        // Check if response has success status
        if (res?.data?.status === "SUCCESS") {
          // Directly show success and close modal
          okSuccessToast("Outlet registration completed successfully!");
          handleClose();

          setShowStatusModal(true);
          refreshUser();
          if (refresh) refresh();
        } else {
          // If not success, show status modal with reference ID
          setStatusReferenceId(res?.data?.data?.otpReferenceID || "");
        }
      },
      (error) => {
        apiErrorToast(error);
      },
    );
  };

  const handleStatusModalClose = (statusData) => {
    setShowStatusModal(false);
    handleClose();

    if (statusData?.status === "SUCCESS" && refresh) {
      refresh();
    }
  };

  return (
    <>
      <Modal
        open={open === AEPS_TYPE.AEPS1}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEscapeKeyDown={request}
        disableBackdropClick={request}
      >
        <Box sx={style} className="sm_modal">
          <Loader loading={request} />
          <ModalHeader title="Outlet Registration" handleClose={handleClose} />
          <Box
            component="form"
            id="outletRegistration"
            validate
            autoComplete="off"
            onSubmit={outletRegistration}
            sx={{
              "& .MuiTextField-root": { m: 1 },
            }}
          >
            <Grid container sx={{ pt: 1 }}>
              {/* Full Name Field */}
              <Grid item xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Full Name"
                    id="name"
                    name="name"
                    size="small"
                    required
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      setIsValidName(true);
                    }}
                    error={!isValidName}
                    helperText={!isValidName ? "Full name is required" : ""}
                  />
                </FormControl>
              </Grid>

              {/* Gender Field */}
              <Grid item xs={12} md={6}>
                <FormControl
                  fullWidth
                  size="small"
                  required
                  error={!isValidGender}
                >
                  <InputLabel id="gender-label">Gender</InputLabel>
                  <Select
                    labelId="gender-label"
                    id="gender"
                    name="gender"
                    value={gender}
                    label="Gender"
                    onChange={(e) => {
                      setGender(e.target.value);
                      setIsValidGender(true);
                    }}
                  >
                    <MenuItem value="M">Male</MenuItem>
                    <MenuItem value="F">Female</MenuItem>
                    <MenuItem value="OTHER">Other</MenuItem>
                  </Select>
                  {!isValidGender && (
                    <span
                      style={{
                        color: "#d32f2f",
                        fontSize: "0.75rem",
                        marginLeft: "14px",
                        marginTop: "3px",
                      }}
                    >
                      Gender is required
                    </span>
                  )}
                </FormControl>
              </Grid>

              {/* Date of Birth Field */}
              <Grid item xs={12} md={6}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Date of Birth"
                    id="dateOfBirth"
                    name="dateOfBirth"
                    size="small"
                    required
                    type="date"
                    value={dateOfBirth}
                    onChange={(e) => {
                      setDateOfBirth(e.target.value);
                      setIsValidDate(true);
                    }}
                    error={!isValidDate}
                    helperText={!isValidDate ? "Date of birth is required" : ""}
                    InputLabelProps={{ shrink: true }}
                  />
                </FormControl>
              </Grid>

              {/* Mobile Number Field */}
              <Grid item xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Mobile Number"
                    id="mobile"
                    name="mobile"
                    size="small"
                    required
                    helperText={
                      !isValMob
                        ? "Please enter a valid 10-digit mobile number"
                        : ""
                    }
                    error={!isValMob}
                    onChange={(e) => {
                      const isValid = PATTERNS.MOBILE.test(e.target.value);
                      setIsValMob(isValid);
                    }}
                    inputProps={{ maxLength: 10, minLength: 10 }}
                  />
                </FormControl>
              </Grid>

              {/* PAN Field */}
              <Grid item xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="PAN"
                    id="pan"
                    name="pan"
                    size="small"
                    required
                    inputProps={{ maxLength: 10 }}
                  />
                </FormControl>
              </Grid>

              {/* Aadhaar Field */}
              <Grid item xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Aadhaar"
                    id="aadhaar"
                    name="aadhaar"
                    size="small"
                    required
                    inputProps={{ maxLength: 12 }}
                  />
                </FormControl>
              </Grid>

              {/* Email ID Field */}
              <Grid item xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Email ID"
                    id="emailId"
                    name="emailId"
                    size="small"
                    required
                    type="email"
                  />
                </FormControl>
              </Grid>

              {/* Bank Account Number Field */}
              <Grid item xs={12} md={6}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Bank account number"
                    id="bankAccountNo"
                    name="bankAccountNo"
                    size="small"
                    required
                  />
                </FormControl>
              </Grid>

              {/* Bank IFSC Field */}
              <Grid item xs={12} md={6}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Bank IFSC"
                    id="bankIfsc"
                    name="bankIfsc"
                    size="small"
                    required
                  />
                </FormControl>
              </Grid>

              {/* Full Address Field */}
              <Grid item xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Full Address"
                    id="fullAddress"
                    name="fullAddress"
                    size="small"
                    required
                    multiline
                    rows={2}
                    value={address.full}
                    onChange={(e) =>
                      setAddress({ ...address, full: e.target.value })
                    }
                  />
                </FormControl>
              </Grid>

              {/* City Field */}
              <Grid item xs={12} md={8}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="City"
                    id="city"
                    name="city"
                    size="small"
                    required
                    value={address.city}
                    onChange={(e) =>
                      setAddress({ ...address, city: e.target.value })
                    }
                  />
                </FormControl>
              </Grid>

              {/* Pincode Field */}
              <Grid item xs={12} md={4}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Pincode"
                    id="pincode"
                    name="pincode"
                    size="small"
                    required
                    value={address.pincode}
                    onChange={(e) => {
                      const pincode = e.target.value;
                      setAddress({ ...address, pincode });
                      setIsValidPincode(
                        PATTERNS.PINCODE?.test(pincode) || pincode === "",
                      );
                    }}
                    error={!isValidPincode}
                    helperText={
                      !isValidPincode
                        ? "Please enter a valid 6-digit pincode"
                        : ""
                    }
                    inputProps={{ maxLength: 6 }}
                  />
                </FormControl>
              </Grid>

              {/* Consent Checkbox */}
              <Grid item xs={12} sx={{ mt: 2 }}>
                <FormControlLabel
                  size="small"
                  control={
                    <Checkbox
                      sx={{
                        color: primaryColor(),
                        "&.Mui-checked": {
                          color: primaryColor(),
                        },
                      }}
                      checked={isConsent}
                      onChange={(e) => {
                        setIsConsent(e.target.checked);
                      }}
                    />
                  }
                  label={
                    <span style={{ fontSize: "0.7rem" }}>
                      I hereby give my consent and submit voluntarily at my own
                      discretion, my Aadhaar Number or VID for the purpose of
                      establishing my identity on the portal. The Aadhaar
                      submitted herewith shall not be used for any purpose other
                      than mentioned, or as per the requirements of the law.
                    </span>
                  }
                />
              </Grid>
            </Grid>
          </Box>
          <ModalFooter
            form="outletRegistration"
            request={request}
            btn="Continue"
            disabled={request || !isConsent}
          />
        </Box>
      </Modal>

      {/* Status Modal - Only shown when needed */}
      {showStatusModal && (
        <Aeps1OutletStatusIpay
          open={showStatusModal}
          onClose={handleStatusModalClose}
          referenceId={statusReferenceId}
          refreshCallback={(data) => {
            if (data?.status === "SUCCESS") {
              okSuccessToast("Outlet registration completed successfully!");
              handleClose();
              if (refresh) refresh();
            }
          }}
          showLoader={request}
        />
      )}
    </>
  );
};

export default AePSOutletRegistration;
